import { render, staticRenderFns } from "./user-uploadcertificate.vue?vue&type=template&id=7969ab6c&scoped=true"
import script from "./user-uploadcertificate.vue?vue&type=script&lang=js"
export * from "./user-uploadcertificate.vue?vue&type=script&lang=js"
import style0 from "./user-uploadcertificate.vue?vue&type=style&index=0&id=7969ab6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7969ab6c",
  null
  
)

export default component.exports